document.addEventListener('DOMContentLoaded', () => {
    const applicationForm = document.querySelector('[id^="addressForm_kundenclubGarantieverlaengerungPartnerhandwerker"]') as HTMLFormElement | null;
    if (applicationForm) {
        const companyField = applicationForm.querySelector('input[name$="[text-6]"]') as HTMLInputElement | null;
        const cityField = applicationForm.querySelector('input[name$="[text-4]"]') as HTMLInputElement | null;
        const contactField = applicationForm.querySelector('input[name$="[text-5]"]') as HTMLInputElement | null;
        const emailField = applicationForm.querySelector('input[name$="[email-2]"]') as HTMLInputElement | null;
        fetch('/api/form-prefill', {
            method: 'GET',
            credentials: 'same-origin',
        }).then(response => {
            if (response.ok) {
                return response.json().then(data => {
                    if (companyField) {
                        companyField.value = data.company || '';
                    }

                    if (cityField) {
                        cityField.value = data.city || '';
                    }

                    if (contactField) {
                        contactField.value = `${data.firstName} ${data.lastName}` || '';
                    }

                    if (emailField) {
                        emailField.value = data.email || '';
                    }
                });
            }
        })
    }
})
